import React from 'react';
import { Typography, TextField, Select, Grid } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/system';
import IconButton from '@mui/material/IconButton';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentNeutralRoundedIcon from '@mui/icons-material/SentimentNeutralRounded';

const MainContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60vh',
    padding: '10px',
    width: '90%'
});
const DialogContent = styled('div')({
    maxWidth: '100vw',
    overflow: 'auto',
    overflowX: 'hidden',
});

const GenerateButton = styled('button')({
    marginTop: '10px',
    backgroundColor: '#2560CD',
    padding: '10px 25px',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    cursor: 'pointer',
    borderRadius: '12px',
    '&:hover': {
        background: 'black',
        color: 'white',
    },
});

const ActivityInput = ({ onSave, onCancel }) => {
    const [activity, setActivity] = React.useState('');
    const [highestLevel, setHighestLevel] = React.useState('');
    const [outcome, setOutcome] = React.useState('');
    const [activityType, setActivityType] = React.useState('');
    const [participationType, setParticiaptionType] = React.useState('');
    const [enjoyment, setEnjoyment] = React.useState('');
    const [allFieldsFilled, setAllFieldsFilled] = React.useState(false);
    const [saveClicked, setSaveClicked] = React.useState(false);
    const [participationLevelEnabled, setParticipationLevelEnabled] = React.useState(false);

    const handleActivityChange = (event) => {
        setActivity(event.target.value);
    };

    const handleHighestLevelChange = (event) => {
        setHighestLevel(event.target.value);
    };

    const handleOutcomeChange = (event) => {
        setOutcome(event.target.value);
    };

    const handleActivityTypeChange = (event) => {
        setActivityType(event.target.value);
    };

    const handleParticipationTypeChange = (event) => {
        setParticiaptionType(event.target.value);
        setParticipationLevelEnabled(true);
    };

    const handleEnjoymentChange = (value) => {
        setEnjoyment(value);
    };

    React.useEffect(() => {
        const isFilled = activity && highestLevel && outcome && activityType && enjoyment !== undefined && participationType;
        setAllFieldsFilled(isFilled);
    }, [activity, highestLevel, outcome, activityType, enjoyment, participationType]);

    const renderParticipationLevelOptions = () => {
        return [
            <MenuItem key="international" value={5} style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
            }}>International</MenuItem>,
            <MenuItem key="national" value={4} style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
            }}>National</MenuItem>,
            <MenuItem key="State/ Regional" value={3} style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
            }}>State/ Regional</MenuItem>,
            <MenuItem key="District/ Local" value={2} style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
            }}>District/ Local</MenuItem>,
            <MenuItem key="School/City" value={1} style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
            }}>School/City</MenuItem>
        ];
    };

    return (
        <MainContainer>
            <DialogContent>
                <Typography style={{
                    fontSize: '20px',
                    borderBottom: '2px solid #D8D0D0',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                }}>Add Activity</Typography>
                <Grid container spacing={2} style={{ paddingTop: 20 }}>
                    <Grid item xs={12} sm={6}>
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>Extra-curricular/ Professional Activity</Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            value={activity}
                            onChange={handleActivityChange}
                            InputProps={{
                                style: {
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    borderRadius: '12px'
                                },
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>What was your role?<span style={{ color: 'red', marginLeft: '4px' }}>*
                            </span></Typography>
                        <Select
                            value={activityType}
                            onChange={handleActivityTypeChange}
                            fullWidth
                            sx={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif', fontSize: '14px', fontWeight: 500 }}
                        >
                            <MenuItem value={3} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Team Leader</MenuItem>
                            <MenuItem value={2} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Team Member</MenuItem>
                            <MenuItem value={1} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Individual Contributor</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>Where did you participate?<span style={{ color: 'red', marginLeft: '4px' }}>*
                            </span></Typography>
                        <Select
                            value={participationType}
                            onChange={handleParticipationTypeChange}
                            fullWidth
                            sx={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif', fontSize: '14px', fontWeight: 500 }}
                        >
                            <MenuItem value="Academic (Schools/ Colleges)" style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Academic (Schools/ Colleges)</MenuItem>
                            <MenuItem value="Corporate/ Professional" style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Corporate/ Professional</MenuItem>
                            <MenuItem value="Institutional/ Public" style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Institutional/ Public</MenuItem>
                            <MenuItem value="Social Media" style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Social Media</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>Impact/ Contribution/ Participation Level<span style={{ color: 'red', marginLeft: '4px' }}>*
                            </span></Typography>
                        <Select
                            value={highestLevel}
                            onChange={handleHighestLevelChange}
                            disabled={!participationLevelEnabled}
                            fullWidth
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                borderRadius: '12px'
                            }}
                        >
                            {renderParticipationLevelOptions()}
                        </Select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>How was your overall performance?<span style={{ color: 'red', marginLeft: '4px' }}>*
                            </span></Typography>
                        <Select
                            value={outcome}
                            onChange={handleOutcomeChange}
                            fullWidth
                            sx={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif' }}
                        >
                            <MenuItem value={5} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Well above average</MenuItem>
                            <MenuItem value={4} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Above average</MenuItem>
                            <MenuItem value={3} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Average</MenuItem>
                            <MenuItem value={2} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Below Average</MenuItem>
                            <MenuItem value={1} style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>NA</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>Was this activity enjoyable for you?<span style={{ color: 'red', marginLeft: '4px' }}>*
                            </span></Typography>
                        <div style={{ border: '1px solid #D8D0D0', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <IconButton
                                aria-label="Yes"
                                onClick={() => handleEnjoymentChange(3)}
                                color={enjoyment === 3 ? 'primary' : 'default'}
                            >
                                <InsertEmoticonIcon fontSize='large' />
                                <Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '12px'
                                }}>Enjoyed</Typography>
                            </IconButton>
                            <IconButton
                                aria-label="neutral"
                                onClick={() => handleEnjoymentChange(2)}
                                color={enjoyment === 2 ? 'primary' : 'default'}
                            >
                                <SentimentNeutralRoundedIcon fontSize='large' />
                                <Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '12px'
                                }}>Neutral</Typography>
                            </IconButton>
                            <IconButton
                                aria-label="No"
                                onClick={() => handleEnjoymentChange(1)}
                                color={enjoyment === 1 ? 'primary' : 'default'}
                            >
                                <SentimentVeryDissatisfiedIcon fontSize='large' />
                                <Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '12px'
                                }}>Didn’t Enjoy</Typography>
                            </IconButton>
                        </div>
                    </Grid>
                </Grid>
                {saveClicked && !allFieldsFilled && (
                    <Typography variant="caption" color="error" style={{
                        marginTop: '10px', fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '16px'
                    }}>
                        Please fill in all required fields.
                    </Typography>
                )}
                <div style={{
                    display: 'flex', justifyContent: 'space-between'
                }}>
                    <GenerateButton onClick={onCancel}>Cancel</GenerateButton>
                    <GenerateButton
                        onClick={() => {
                            setSaveClicked(true);
                            if (allFieldsFilled) {
                                onSave({ activity, highestLevel, outcome, activityType, enjoyment, participationType });
                            }
                        }}
                    >
                        Save
                    </GenerateButton>
                </div>
            </DialogContent>
        </MainContainer>
    );
}

export default ActivityInput;